"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IHttpRequestResult = /** @class */ (function () {
    function IHttpRequestResult(response, error) {
        this.response = response;
        this.error = error;
    }
    return IHttpRequestResult;
}());
exports.IHttpRequestResult = IHttpRequestResult;
//# sourceMappingURL=http.models.js.map